import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class StudentAnswerService extends Service{
    constructor() {
        super();
        this.baseURL = 'studentAnswer';
    }

    create(data) {
        return fetch(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: JSON.stringify(GeneralUtils.addCreateInfo(data))
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    update(data) {
        return fetch(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'put',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: JSON.stringify(GeneralUtils.addUpdateInfo(data))
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    delete(id) {
        return fetch(SERVER_URL + this.baseURL + '/' + id, {
            crossDomain: true,
            method: 'delete',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findByStudentExamId(studentExamId) {
        return fetch(SERVER_URL + this.baseURL + '/findByStudentExamId/' + studentExamId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}